import { mapGetters } from 'vuex'
import { qingsuCheckOnline } from 'api/qingsu'
import { getScrollTop } from 'lib/tools/utils'
import qs from 'qs'

export default {
  methods: {
    // 滚动方向
    getScrollDirection(afterScrollTop = getScrollTop()) {
      if (afterScrollTop < 100) return 'down'
      if (!this.beforeScrollTop) {
        this.beforeScrollTop = afterScrollTop
      }
      if (afterScrollTop < 0) {
        return 'down'
      }
      if (
        afterScrollTop >
        document.body.scrollHeight - window.screen.availHeight
      ) {
        return 'up'
      }
      const _beforeScrollTop = this.beforeScrollTop
      this.beforeScrollTop = afterScrollTop
      return afterScrollTop - _beforeScrollTop > 0 ? 'up' : 'down'
    },

    toFastOrder(params = {}) {
      // app里未登录
      if (!this.isLogin && (this.$platform.isYixinliApp || this.isWebviewMp)) {
        this.toLogin()
        return Promise.reject({
          code: 40001,
          message: '请先登录'
        })
      }
      return qingsuCheckOnline({
        cid: this.$route.query.cid || ''
      }).then(res => {
        const { code, message } = res
        if (code === 0) {
          this.routerToStaic({
            path: '/qingsu-order-page',
            query: {
              cid: this.$route.query.cid,
              cp_channel_id: this.$route.query.cpChannelId || '', //机构的渠道id
              ...params
            }
          })
        } else if (code === -10 || code === -11) {
          // 弃用$fail，改用弹窗，具体实现见toFastOrder.then
          // this.$fail(`当前没有能服务的倾听师，请晚点再来吧~`)
        } else {
          this.$toast(message)
        }
        return Promise[code === 0 ? 'resolve' : 'reject'](res)
      })
    },

    // toHomePage: 是否跳去新版个人主页
    toTeacherDetail(item, toHomePage = false) {
      const query = {
        id: item.user_id,
        _version: this.$route.query._version || '',
        cid: this.$route.query.cid || '',
        channel_flag: this.$route.query.channel_flag || '',
        source: item.source || '',
        cp_channel_id: this.$route.query.cpChannelId || '', //机构的渠道id
        fromQingSuPage: item.fromQingSuPage || ''
      }
      if (item.qingsuService) {
        query.qingsuService = item.qingsuService
      }
      if (item.isTextShow) {
        // 是否显示文字倾诉服务
        query.isTextShow = item.isTextShow
      }
      if (toHomePage) {
        this.routerPushWithoutNav({
          path: `/consult/${item.user_id}.html`,
          query
        })
      } else {
        this.routerToStaic({
          path: '/qingsu-teacher-page',
          query
        })
      }
    },

    getChannelRouteToQuerys(cid = this.$route.query.cid) {
      if (+cid === 209) {
        return {
          coupon_id: 2144
        }
      }

      return {}
    },
    /* eslint-disable */
    async mixinToTextOrder(params = {}) {
      if (!this.isLogin && this.$platform.isYixinliApp) {
        window.location.href = 'yixinli://open_user_login'
        return Promise.reject({
          code: 40001,
          message: '请先登录'
        })
      }
      const isTeacher = this.consultTeacherInfo || this.qingtingInfo

      // 现在倾听师跟咨询师都可以接文字订单，所以他们不能互相下文字订单
      if (isTeacher) {
        this.$toast({
          text: '暂不支持老师之间相互下单',
          zIndexTop: true
        })
        return
      }
      let path =
        params.wayType == 'text'
          ? '/consult-text/order-page'
          : '/qingsu-order-page'
      // path: '/qingsu-order-page',
      this.routerToStaic({
        path,
        query: {
          cid: this.$route.query.cid,
          ...params
        }
      })
    },
    toHomepage(item) {
      const query = {
        _version: this.$route.query._version || '',
        cid: this.$route.query.cid || '',
        channel_flag: this.$route.query.channel_flag || '',
        source: item.source || '',
        cp_channel_id: this.$route.query.cpChannelId || '', //机构的渠道id
        fromQingSuPage: item.fromQingSuPage || ''
      }
      if (item.qingsuService) {
        query.qingsuService = item.qingsuService
      }
      if (item.isTextShow) {
        // 是否显示文字倾诉服务
        query.isTextShow = item.isTextShow
      }
      const url = `${window.location.origin}/homepage/${
        item.user_id
      }?${qs.stringify(query)}`

      if (this.$platform.isYixinliApp) {
        this.$bridge.openWebView({
          url,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
      } else {
        window.location.href = url
      }
    }
  },

  computed: {
    ...mapGetters(['isLogin']),
    consultTeacherInfo() {
      return this.$store.getters.consultTeacherInfo
    },
    qingtingInfo() {
      return this.$store.getters.qingtingInfo
    }
    //  57渠道---已下线
    // isFreeQingsu() {
    //   return this.$route.query.cid == 57
    // }
  }
}
